// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"448":"63e83a4a","540":"1f18af89","649":"b4666c66","661":"34fe5711"}[chunkId] + ".chunk.js";
};